import {
  Server,
  Code,
  Cloud,
  Database,
  Cpu,
  Palette,
} from "lucide-react";

export const stacks = [
  {
    title: "Backend",
    icon: Server,
    gradient: "from-blue-500 to-cyan-500",
    items: [
      "Django",
      "PHP",
      "Python",
      "Laravel",
      "CodeIgniter",
      "Node.js",
      "Express.js",
      "Nest.js",
    ],
  },
  {
    title: "Frontend",
    icon: Code,
    gradient: "from-purple-500 to-pink-500",
    items: [
      "React",
      "Vue.js",
      "Angular",
      "Next.js",
      "TypeScript",
      "JavaScript",
      "HTML5",
      "CSS3",
    ],
  },
  {
    title: "DevOps",
    icon: Cloud,
    gradient: "from-green-500 to-teal-500",
    items: [
      "Docker",
      "Kubernetes",
      "AWS",
      "Azure",
      "Jenkins",
      "GitLab",
      "Nginx",
      "Linux",
    ],
  },
  {
    title: "Database & Development",
    icon: Database,
    gradient: "from-orange-500 to-red-500",
    items: [
      "MongoDB",
      "PostgreSQL",
      "MySQL",
      "Redis",
      "Firebase",
      "Oracle",
      "SQLite",
      "Cassandra",
    ],
  },
  {
    title: "Artificial Intelligence",
    icon: Cpu,
    gradient: "from-indigo-500 to-purple-500",
    items: [
      "TensorFlow",
      "PyTorch",
      "OpenCV",
      "Jupyter",
      "Pandas",
      "NumPy",
      "Keras",
      "Scikit-learn",
    ],
  },
  {
    title: "Design",
    icon: Palette,
    gradient: "from-pink-500 to-rose-500",
    items: [
      "Figma",
      "Adobe XD",
      "Photoshop",
      "Illustrator",
      "Sketch",
      "InVision",
      "Canva",
      "After Effects",
    ],
  },
];
